let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("lkJNx"), load("dWaws"), load("cyI3V")]).then(() => parcelRequire('g6WWI'));